import axios from "axios";

export const getAccessTokenAlgoritmo = (payload?) => {
    const data = axios.get(process.env.URL_COMFAMA_TOKEN_ALGORITMO)
    return data;
};
